module.exports = __webpack_public_path__ + "static/media/vf_wdressshoes_core.ca412221.svg";